(function () {
  function init() {
    var root = document.getElementById('gGPpHKVZVX');
    if (!root || root.getAttribute('data-ready') === '1') return;
    root.setAttribute('data-ready', '1');
    function $(id) { return root.querySelector('#' + id); }
    function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    var FN_URL = 'https://wnfnqhtrgimyxvyoccxd.supabase.co/functions/v1/sticker-quote';
    var STORAGE_UPLOAD_BASE = 'https://wnfnqhtrgimyxvyoccxd.supabase.co/storage/v1/object/upload/sign/sticker-quote-artwork/';
    var FALLBACK_WEBHOOK = 'https://hook.eu1.make.com/swrhm6bkjhj6k2w1b5jmsvkfr9q87sqn';
    var WHATSAPP = '6596584561';
    var MAX_FILES = 5, MAX_TOTAL = 25000000, MAX_QTY = 100000;
    // Slider stops: fine steps at the low end, bigger jumps as quantities grow.
    var STOPS = [1, 2, 3, 5, 10, 15, 20, 30, 40, 50, 60, 80, 100, 150, 200, 250, 300, 400, 500, 600, 800, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 6000, 8000, 10000];
    // "Order a few more" ladder for the savings hint: small first jump so the saving stays realistic.
    var LADDER = [1, 10, 20, 30, 50, 100, 200, 300, 500, 1000, 2000, 3000, 5000, 10000];

    var SIZES = {
      '3x3': { label: '3 × 3 cm', w: 3, h: 3, legacy: '3cm x 3cm' },
      '4x4': { label: '4 × 4 cm', w: 4, h: 4, legacy: '4cm x 4cm' },
      '5x5': { label: '5 × 5 cm', w: 5, h: 5, legacy: '5cm x 5cm' },
      '6x6': { label: '6 × 6 cm', w: 6, h: 6, legacy: '6cm x 6cm' },
      'A6': { label: 'A6, 10.5 × 14.8 cm', w: 10.5, h: 14.8, legacy: 'A6 (10.5cm x 14.8cm)' },
      'A5': { label: 'A5, 14.8 × 21 cm', w: 14.8, h: 21, legacy: 'A5 (14.8cm x 21cm)' },
      'A4': { label: 'A4, 21 × 29.7 cm', w: 21, h: 29.7, legacy: 'A4 (21cm x 29.7cm)' }
    };
    var SHAPES = { round: 'Round', square: 'Square', custom: 'Custom Shape' };
    var SHAPE_LABEL = { round: 'Round', square: 'Square or rectangle', custom: 'Custom shape' };
    var CUTS = { 'die-cut': 'Die Cut', 'kiss-cut': 'Kiss Cut + Die Cut', sheet: 'Sheet' };
    var CUT_LABEL = { 'die-cut': 'Die cut', 'kiss-cut': 'Kiss cut + die cut', sheet: 'Sticker sheet' };
    var MIME = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', pdf: 'application/pdf', ai: 'application/postscript', psd: 'image/vnd.adobe.photoshop', svg: 'image/svg+xml' };

    var s = { size: '5x5', w: '', h: '', qty: 50, shape: 'round', cut: 'die-cut', finish: 'matte', contact: 'email', files: [], skipped: [], busy: false, price: null };

    function ext(n) { var m = String(n || '').toLowerCase().match(/\.([a-z0-9]+)$/); return m ? m[1] : ''; }
    function fmt(n) { return n.toFixed(2); }
    function dims() {
      if (s.size === 'custom') { var w = parseFloat(s.w), h = parseFloat(s.h); return (w > 0 && h > 0) ? { w: w, h: h } : null; }
      return { w: SIZES[s.size].w, h: SIZES[s.size].h };
    }

    // Same pricing formula as the original tool.
    function priceFor(qty) {
      var d = dims() || { w: 0, h: 0 };
      var area = (d.w * d.h * qty) / 10000;
      var perSqm = 30 + (105 - 30) * Math.exp(-0.077 * area);
      var print = area * perSqm;
      var shapeFee = s.shape === 'custom' ? 5 : 0;
      var cutFee = (s.cut === 'kiss-cut' || s.cut === 'sheet') ? Math.min(qty * 0.05, 25) : 0;
      var handling = qty * 0.01;
      var total = print + 13.5 + shapeFee + cutFee + handling;
      return { base: 13.5, print: print, handling: handling, shapeFee: shapeFee, cutFee: cutFee, total: total, each: qty > 0 ? total / qty : 0 };
    }

    // ----- Preview drawing -----
    var SVGNS = 'http://www.w3.org/2000/svg';
    function el(tag, attrs) { var e = document.createElementNS(SVGNS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }
    var BLOB = 'M-0.62,-0.70 C-0.20,-1.05 0.18,-0.62 0.52,-0.78 C0.92,-0.95 1.02,-0.30 0.80,0.05 C0.62,0.33 0.98,0.72 0.48,0.86 C0.04,0.98 -0.20,0.62 -0.58,0.80 C-1.00,0.98 -1.08,0.28 -0.86,-0.06 C-0.70,-0.30 -1.00,-0.52 -0.62,-0.70 Z';
    function drawShape(g, cx, cy, w, h, kind, cls, pad) {
      var hw = w / 2 + pad, hh = h / 2 + pad;
      if (kind === 'round') return g.appendChild(el('ellipse', { cx: cx, cy: cy, rx: hw, ry: hh, 'class': cls }));
      if (kind === 'square') return g.appendChild(el('rect', { x: cx - hw, y: cy - hh, width: hw * 2, height: hh * 2, rx: Math.min(hw, hh) * 0.12, 'class': cls }));
      return g.appendChild(el('path', { d: BLOB, transform: 'translate(' + cx + ',' + cy + ') scale(' + hw + ',' + hh + ')', 'class': cls, 'vector-effect': 'non-scaling-stroke' }));
    }
    function drawPreview() {
      var svg = $('sq-preview');
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var d = dims() || { w: 5, h: 5 };
      var ratio = d.w / d.h;
      var maxW = 130, maxH = 130;
      var w = ratio >= 1 ? maxW : maxH * ratio, h = ratio >= 1 ? maxW / ratio : maxH;
      var g = el('g', { 'class': 'sq-anim' });
      svg.appendChild(g);
      var cx = 110, cy = 95;
      if (s.cut === 'sheet') {
        var sw = Math.max(w, 120) + 30, sh = Math.max(h, 120) + 30;
        g.appendChild(el('rect', { x: cx - sw / 2, y: cy - sh / 2, width: sw, height: sh, rx: 6, 'class': 'sq-shape-sheet' }));
        var mw = (sw - 36) / 2, mh = (sh - 36) / 2, sc = Math.min(mw / w, mh / h) * 0.8;
        [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (p) {
          var x = cx + p[0] * (mw / 2 + 6), y = cy + p[1] * (mh / 2 + 6);
          drawShape(g, x, y, w * sc, h * sc, s.shape, 'sq-shape-cut', 3);
          drawShape(g, x, y, w * sc, h * sc, s.shape, 'sq-shape-art', -4);
        });
      } else {
        if (s.cut === 'kiss-cut') {
          var bw = w + 34, bh = h + 34;
          g.appendChild(el('rect', { x: cx - bw / 2, y: cy - bh / 2, width: bw, height: bh, rx: 10, 'class': 'sq-shape-sheet' }));
        }
        drawShape(g, cx, cy, w, h, s.shape, 'sq-shape-cut', 6);
        drawShape(g, cx, cy, w, h, s.shape, 'sq-shape-art', -6);
      }
      g.appendChild(el('path', { d: 'M' + (cx - 70) + ',' + (cy + 70) + ' L' + (cx + 20) + ',' + (cy - 80) + ' L' + (cx + 40) + ',' + (cy - 80) + ' L' + (cx - 50) + ',' + (cy + 70) + ' Z', 'class': 'sq-sheen' }));
      var clip = el('clipPath', { id: 'sq-clip' });
      var cl = s.cut === 'sheet' ? null : drawShape(el('g', {}), cx, cy, w, h, s.shape, '', -6);
      if (cl) { clip.appendChild(cl.cloneNode(true)); svg.insertBefore(clip, g); g.lastChild.setAttribute('clip-path', 'url(#sq-clip)'); }
      $('sq-caption').textContent = s.size === 'custom' ? (dims() ? fmtDim(d.w) + ' × ' + fmtDim(d.h) + ' cm' : 'Custom size') : SIZES[s.size].label.replace(/^A\d, /, '');
    }
    function fmtDim(n) { return String(Math.round(n * 10) / 10); }

    // ----- Render -----
    function render() {
      var p = priceFor(s.qty);
      s.price = p;
      $('sq-total').textContent = fmt(p.total);
      $('sq-each').textContent = 'SGD ' + fmt(p.each);
      $('sq-bar-total').textContent = fmt(p.total);
      $('sq-bar-each').textContent = fmt(p.each);
      $('sq-b-base').textContent = fmt(p.base);
      $('sq-b-print').textContent = fmt(p.print);
      $('sq-b-handling').textContent = fmt(p.handling);
      $('sq-b-shape').textContent = fmt(p.shapeFee);
      $('sq-b-cut').textContent = fmt(p.cutFee);
      $('sq-s-qty').textContent = s.qty.toLocaleString('en-SG') + ' pcs';
      var d = dims();
      $('sq-s-size').textContent = s.size === 'custom' ? (d ? fmtDim(d.w) + ' × ' + fmtDim(d.h) + ' cm' : 'Custom, enter size') : SIZES[s.size].label;
      $('sq-s-shape').textContent = SHAPE_LABEL[s.shape];
      $('sq-s-cut').textContent = CUT_LABEL[s.cut];
      $('sq-s-finish').textContent = s.finish === 'matte' ? 'Matte' : 'Gloss';
      $('sq-s-art').textContent = s.files.length ? s.files.length + ' file' + (s.files.length > 1 ? 's' : '') : 'Not added';
      root.setAttribute('data-finish', s.finish);

      // Bigger-order nudge
      var hint = '';
      if (dims()) {
        if (s.qty < 10) {
          // Small orders: show how little extra it costs to reach 10 stickers
          var p10 = priceFor(10), extra = p10.total - p.total, more10 = 10 - s.qty;
          hint = 'Add ' + jump(10, more10 + ' more') + ' to get 10 stickers for only SGD ' + fmt(extra) + ' extra in total (SGD ' + fmt(p10.each) + ' each).';
        } else {
          var next = LADDER.filter(function (t) { return t > s.qty; })[0];
          if (next) {
            var np = priceFor(next);
            var pct = Math.round((1 - np.each / p.each) * 100);
            if (pct >= 1) hint = 'Order ' + jump(next, next.toLocaleString('en-SG')) + ' and pay SGD ' + fmt(np.each) + ' each, ' + pct + '% cheaper per sticker.';
          }
        }
      }
      $('sq-tier-hint').innerHTML = hint;
      syncRange();
      drawPreview();
    }

    function jump(q, label) {
      return '<button type="button" class="sq-jump" data-qty="' + q + '" style="all:unset;cursor:pointer;color:inherit;text-decoration:underline;text-decoration-color:var(--sq-red);text-decoration-thickness:2px;text-underline-offset:3px;" aria-label="Change quantity to ' + q + '">' + label + '</button>';
    }
    $('sq-tier-hint').addEventListener('click', function (e) {
      var b = e.target.closest('.sq-jump');
      if (!b) return;
      var q = parseInt(b.getAttribute('data-qty'), 10);
      $('sq-qty').value = q; setQty(q);
    });
    var range = $('sq-qty-range');
    range.max = STOPS.length - 1;
    function stopIndex(q) { var i = 0; for (var k = 0; k < STOPS.length; k++) { if (STOPS[k] <= q) i = k; } return i; }
    function syncRange() {
      var i = stopIndex(s.qty);
      range.value = i;
      var pct = (i / (STOPS.length - 1)) * 100;
      range.style.setProperty('--sq-fill', pct + '%');
      range.setAttribute('aria-valuetext', s.qty.toLocaleString('en-SG') + ' stickers');
    }
    range.addEventListener('input', function () { var q = STOPS[parseInt(this.value, 10)]; $('sq-qty').value = q; setQty(q); });

    function setQty(v) {
      var n = parseInt(v, 10);
      if (!isFinite(n) || n < 1) return;
      s.qty = Math.min(n, MAX_QTY);
      if (document.activeElement !== $('sq-qty')) $('sq-qty').value = s.qty;
      render();
    }

    // ----- Choice groups -----
    all('[data-group]').forEach(function (group) {
      var name = group.getAttribute('data-group');
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-value]');
        if (!btn || !group.contains(btn)) return;
        var v = btn.getAttribute('data-value');
        Array.prototype.forEach.call(group.querySelectorAll('button[data-value]'), function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        if (name === 'size') {
          s.size = v;
          $('sq-custom-size').classList.toggle('is-open', v === 'custom');
          if (v === 'custom') $('sq-width').focus();
          showError('sq-size-error', false);
        }
        if (name === 'shape') s.shape = v;
        if (name === 'cut') s.cut = v;
        if (name === 'finish') s.finish = v;
        if (name === 'contact') {
          s.contact = v;
          var wa = v === 'whatsapp';
          $('sq-wa-req').hidden = !wa; $('sq-wa-opt').hidden = wa;
          if (wa) $('sq-whatsapp').focus();
        }
        render();
      });
    });
    $('sq-width').addEventListener('input', function () { s.w = this.value; render(); });
    $('sq-height').addEventListener('input', function () { s.h = this.value; render(); });
    $('sq-qty').addEventListener('input', function () { if (this.value !== '') setQty(this.value); });
    $('sq-qty').addEventListener('blur', function () { if (this.value === '' || parseInt(this.value, 10) < 1) setQty(1); this.value = s.qty; });
    function step(dir) {
      var cur = s.qty, n;
      if (dir > 0) n = cur < 10 ? cur + 1 : (STOPS.filter(function (t) { return t > cur; })[0] || cur + 1000);
      else n = cur <= 10 ? Math.max(1, cur - 1) : (STOPS.filter(function (t) { return t < cur; }).pop() || 1);
      $('sq-qty').value = n; setQty(n);
    }
    $('sq-qty-up').addEventListener('click', function () { step(1); });
    $('sq-qty-down').addEventListener('click', function () { step(-1); });
    $('sq-whatsapp').addEventListener('input', function () {
      var v = this.value.replace(/[^\d+]/g, '');
      this.value = v.replace(/(\d{4})(?=\d)/g, '$1 ');
    });

    // ----- Files -----
    var fileInput = $('sq-file'), drop = $('sq-drop');
    function addFiles(list) {
      var incoming = Array.prototype.slice.call(list || []);
      var notes = [];
      var total = s.files.reduce(function (t, f) { return t + f.file.size; }, 0);
      incoming.forEach(function (file) {
        if (!MIME[ext(file.name)]) { notes.push(file.name + ' is not a PNG, JPG, PDF, AI, PSD or SVG file.'); return; }
        if (s.files.length >= MAX_FILES) { notes.push('Only 5 files can be added, so ' + file.name + ' was left out.'); s.skipped.push(file.name); return; }
        if (total + file.size > MAX_TOTAL) { notes.push(file.name + ' would take you over 25 MB in total.'); s.skipped.push(file.name); return; }
        total += file.size;
        s.files.push({ file: file, url: /^image\/(png|jpeg)$/.test(file.type) ? URL.createObjectURL(file) : '' });
      });
      if (notes.length) notes.push('You can still send the request and share larger files with us on WhatsApp.');
      var n = $('sq-file-notice'); n.textContent = notes.join(' '); n.classList.toggle('is-shown', notes.length > 0);
      try { fileInput.value = ''; } catch (e) {}
      renderFiles();
    }
    function renderFiles() {
      var ul = $('sq-files'); ul.innerHTML = '';
      s.files.forEach(function (f, i) {
        var li = document.createElement('li'); li.className = 'sq-file';
        var th = document.createElement('div'); th.className = 'sq-thumb';
        if (f.url) { var img = document.createElement('img'); img.src = f.url; img.alt = ''; th.appendChild(img); } else { th.textContent = ext(f.file.name).toUpperCase(); }
        var meta = document.createElement('div'); meta.style.minWidth = '0';
        var nm = document.createElement('div'); nm.className = 'sq-file-name'; nm.textContent = f.file.name;
        var sz = document.createElement('div'); sz.className = 'sq-file-size'; sz.textContent = (f.file.size / 1024 / 1024 < 0.1 ? '< 0.1' : (f.file.size / 1024 / 1024).toFixed(1)) + ' MB';
        meta.appendChild(nm); meta.appendChild(sz);
        var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'sq-file-remove'; rm.innerHTML = '&times;'; rm.setAttribute('aria-label', 'Remove ' + f.file.name);
        rm.addEventListener('click', function () { if (f.url) URL.revokeObjectURL(f.url); s.files.splice(i, 1); renderFiles(); });
        li.appendChild(th); li.appendChild(meta); li.appendChild(rm); ul.appendChild(li);
      });
      render();
    }
    drop.addEventListener('click', function () { fileInput.click(); });
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
    drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-dragging'); });
    drop.addEventListener('dragleave', function () { drop.classList.remove('is-dragging'); });
    drop.addEventListener('drop', function (e) { e.preventDefault(); drop.classList.remove('is-dragging'); if (e.dataTransfer) addFiles(e.dataTransfer.files); });
    fileInput.addEventListener('change', function () { addFiles(this.files); });

    // ----- Validation -----
    function showError(id, on) {
      var e = $(id); if (!e) return; e.classList.toggle('is-shown', !!on);
      var input = $(id.replace('-error', '')); if (input) input.setAttribute('aria-invalid', on ? 'true' : 'false');
    }
    ['sq-name', 'sq-email', 'sq-whatsapp'].forEach(function (id) { $(id).addEventListener('input', function () { showError(id + '-error', false); }); });
    function validate() {
      var first = null;
      function fail(id, focusId) { showError(id, true); if (!first) first = $(focusId); }
      if (s.size === 'custom') {
        var w = parseFloat(s.w), h = parseFloat(s.h);
        if (!(w >= 0.5 && w <= 200 && h >= 0.5 && h <= 200)) fail('sq-size-error', 'sq-width');
      }
      if (!$('sq-name').value.trim()) fail('sq-name-error', 'sq-name');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($('sq-email').value.trim())) fail('sq-email-error', 'sq-email');
      if (s.contact === 'whatsapp' && $('sq-whatsapp').value.replace(/\D/g, '').length < 8) fail('sq-whatsapp-error', 'sq-whatsapp');
      if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { first.focus({ preventScroll: true }); }, 350); }
      return !first;
    }

    // ----- Submit -----
    var btn = $('sq-submit'), progress = $('sq-progress'), bar = progress.querySelector('span');
    function busy(on, text) {
      s.busy = on; btn.disabled = on; btn.textContent = on ? (text || 'Sending...') : 'Send quote request';
      progress.classList.toggle('is-shown', on);
      if (!on) bar.style.width = '0';
    }
    function formError(html) { var e = $('sq-form-error'); e.innerHTML = html || ''; e.classList.toggle('is-shown', !!html); }

    function postJson(url, body, ms) {
      var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var t = ctl ? setTimeout(function () { ctl.abort(); }, ms || 30000) : null;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined })
        .then(function (res) {
          if (t) clearTimeout(t);
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok || !data || data.success !== true) { var err = new Error((data && data.error) || ('Status ' + res.status)); err.status = res.status; throw err; }
            return data;
          });
        }, function (err) { if (t) clearTimeout(t); throw err; });
    }

    function uploadOne(file, up, onProgress) {
      return new Promise(function (resolve, reject) {
        var url = STORAGE_UPLOAD_BASE + up.path.split('/').map(encodeURIComponent).join('/') + '?token=' + encodeURIComponent(up.token);
        var form = new FormData(); form.append('cacheControl', '3600'); form.append('', file, file.name);
        var x = new XMLHttpRequest();
        x.open('PUT', url, true); x.setRequestHeader('x-upsert', 'true'); x.timeout = 600000;
        x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded); };
        x.onload = function () { if (x.status >= 200 && x.status < 300) { onProgress(file.size); resolve(); } else reject(new Error('Upload ' + x.status)); };
        x.onerror = function () { reject(new Error('Network error')); };
        x.ontimeout = function () { reject(new Error('Timed out')); };
        x.send(form);
      });
    }

    function uploadAll(files) {
      if (!files.length) return Promise.resolve(null);
      var totalBytes = files.reduce(function (t, f) { return t + f.size; }, 0), loaded = files.map(function () { return 0; });
      function prog(i, b) {
        loaded[i] = b;
        var pct = Math.min(99, Math.round(loaded.reduce(function (a, c) { return a + c; }, 0) / totalBytes * 100));
        btn.textContent = 'Uploading artwork ' + pct + '%'; bar.style.width = pct + '%';
      }
      return postJson(FN_URL, { action: 'create_uploads', files: files.map(function (f) { return { name: f.name, size: f.size, type: MIME[ext(f.name)] }; }) }, 30000)
        .then(function (session) {
          var chain = Promise.resolve();
          files.forEach(function (file, i) {
            chain = chain.then(function () {
              return uploadOne(file, session.uploads[i], function (b) { prog(i, b); })
                .catch(function () { return uploadOne(file, session.uploads[i], function (b) { prog(i, b); }).catch(function () {}); });
            });
          });
          return chain.then(function () { return { requestId: session.requestId, clientToken: session.clientToken }; });
        });
    }

    function details() {
      var d = dims() || { w: '', h: '' };
      var p = s.price;
      return {
        name: $('sq-name').value.trim(),
        contactMethod: s.contact,
        email: $('sq-email').value.trim(),
        whatsapp: $('sq-whatsapp').value.replace(/\D/g, ''),
        notes: $('sq-notes').value.trim(),
        quoteDetails: {
          quantity: s.qty + ' pcs',
          size: s.size === 'custom' ? 'Custom (' + d.w + ' x ' + d.h + ' cm)' : SIZES[s.size].legacy,
          shape: SHAPES[s.shape],
          type: s.finish === 'matte' ? 'Matte White Vinyl' : 'Gloss White Vinyl',
          cuttingMethod: CUTS[s.cut],
          pricing: {
            basePrice: 'SGD $' + fmt(p.base), customShapeFee: 'SGD $' + fmt(p.shapeFee), cuttingFee: 'SGD $' + fmt(p.cutFee),
            printCost: 'SGD $' + fmt(p.print), totalPrice: 'SGD $' + fmt(p.total), perStickerPrice: 'SGD $' + fmt(p.each)
          }
        }
      };
    }

    function waLink(d) {
      var q = d.quoteDetails;
      var t = 'Hi THEIMPRINT, I would like a sticker quote.\nName: ' + d.name + '\nEmail: ' + d.email + '\n' + q.quantity + ', ' + q.size + ', ' + q.shape + ', ' + q.type + ', ' + q.cuttingMethod + '\nQuoted: ' + q.pricing.totalPrice + (d.notes ? '\nNotes: ' + d.notes : '');
      return 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(t);
    }

    function done(d, missing) {
      $('sq-done-wa').href = waLink(d);
      var note = $('sq-done-note');
      if (missing && missing.length) { note.textContent = 'We did not receive ' + missing.join(', ') + '. Please send it to us on WhatsApp and we will add it to your quote.'; note.hidden = false; }
      else note.hidden = true;
      root.classList.add('is-done');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { $('sq-done').focus({ preventScroll: true }); }, 400);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'quoteFormSubmitted' });
    }

    function fallbackToMake(d, names) {
      var x = JSON.parse(JSON.stringify(d));
      if (names.length) x.notes = (x.notes ? x.notes + '\n\n' : '') + 'ARTWORK NOT RECEIVED - please ask the customer to resend: ' + names.join(', ');
      x.quoteDetails.fileUploaded = 'No'; x.quoteDetails.fileCount = 0; x.files = [];
      return fetch(FALLBACK_WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ to: 'preview@theimprint.sg', cc: x.email, subject: 'Sticker Quote Request from ' + x.name, quoteDetails: x }) })
        .then(function (r) { if (!r.ok) throw new Error('Fallback ' + r.status); });
    }

    function submit() {
      if (s.busy) return;
      formError('');
      if (!validate()) return;
      busy(true);
      var d = details();
      var files = s.files.map(function (f) { return f.file; });
      var names = files.map(function (f) { return f.name; }).concat(s.skipped);

      uploadAll(files)
        .catch(function () { return { uploadError: true }; })
        .then(function (up) {
          btn.textContent = 'Sending...'; bar.style.width = '100%';
          var body = {
            action: 'submit_quote', quoteDetails: d, website: $('sq-website').value,
            requestId: up && up.requestId ? up.requestId : undefined, clientToken: up && up.clientToken ? up.clientToken : undefined,
            selectedFileNames: names, uploadFailed: !!(up && up.uploadError)
          };
          var send = function () { return postJson(FN_URL, body, 45000); };
          return send().catch(function (err) {
            if (err && err.status && err.status < 500 && err.status !== 429) throw err;
            return new Promise(function (r) { setTimeout(r, 1500); }).then(send);
          }).then(function (res) { busy(false); done(d, res.missingFiles || []); });
        })
        .catch(function (err) {
          if (err && err.status && err.status < 500 && err.status !== 429) { busy(false); formError(err.message); return; }
          return fallbackToMake(d, names).then(function () { busy(false); done(d, names); })
            .catch(function () {
              busy(false);
              formError('Your request could not be sent because the connection dropped. <a href="' + waLink(d) + '" target="_blank" rel="noopener noreferrer">Send it to us on WhatsApp instead</a>, or try again.');
            });
        });
    }
    btn.addEventListener('click', submit);
    $('sq-form').addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    $('sq-again').addEventListener('click', function () {
      root.classList.remove('is-done');
      s.files.forEach(function (f) { if (f.url) URL.revokeObjectURL(f.url); });
      s.files = []; s.skipped = []; renderFiles();
      $('sq-notes').value = '';
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // ----- Mobile price bar: visible while configuring, hidden once the details step is on screen -----
    var priceBar = $('sq-bar');
    if ('IntersectionObserver' in window) {
      var formVisible = false, detailsVisible = false, summaryVisible = false;
      function sync() { priceBar.classList.toggle('is-shown', formVisible && !detailsVisible && !summaryVisible && !root.classList.contains('is-done')); }
      new IntersectionObserver(function (e) { formVisible = e[0].isIntersecting; sync(); }, { threshold: 0 }).observe($('sq-form'));
      new IntersectionObserver(function (e) { detailsVisible = e[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe($('sq-details'));
      new IntersectionObserver(function (e) { summaryVisible = e[0].isIntersecting; sync(); }, { threshold: 0.3 }).observe(root.querySelector('.sq-summary'));
    }
    $('sq-bar-btn').addEventListener('click', function () { $('sq-details').scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(function () { $('sq-name').focus({ preventScroll: true }); }, 450); });

    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { var r = document.getElementById('gGPpHKVZVX'); if (r) r.removeAttribute('data-ready'); init(); });
})();
